import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './entertainmentcost.json';

const Entertainmentcost = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Explore the economics of entertainment, streaming, and leisure spending. B2 English practice with grammar, vocab, and discussion."
            level="B2"
            title="Entertainment"
            image="/Images/entertainment.webp"
            seoTitle="Free English Lesson Plans: Cost of Entertainment"
            seoDescription="Explore the economics of entertainment, streaming, and leisure spending. B2 English practice with grammar, vocab, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Entertainmentcost;


